/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sticky-bottom[_ngcontent-%COMP%]{position:fixed;bottom:0;left:0;right:0;z-index:1001}"];
export { styles as styles };
//# sourceMappingURL=sticky-bottom.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/footer/sticky-bottom/sticky-bottom.component.scss.shim.ngstyle.js
// module id = 1448
// module chunks = 27 28 29